module.exports = __webpack_public_path__ + "static/media/ionic(1).215d338a.png";